<div *ngIf="departmentList else docitemloading">

  <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                   [typeConfirmation]="typeDeleteConfirmation"
                                   [confirmText]="confirmText"
                                   [messageText]="deleteMessageText"
                                   (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>

  <p-table #departmentTable [value]="departmentList"
           dataKey="CLIID"
           [loading]="loading"
           selectionMode="single"
           [(selection)]="selectedDepartment"
           (onRowSelect)="onRowSelect($event)"
           [rowHover]="true"
           [resizableColumns]="true"
           editMode="row"
           [rows]="rows"
           [paginator]="true"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,25,50]"
           [totalRecords]="totalRecords"
           currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
           [filterDelay]="400"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

    <ng-template pTemplate="caption">
      <div class="grid vertical-container">
        <div class="col align-self-start">
        </div>
        <div class="col align-self-end">
          <div class="grid justify-content-end">
            <p-button label="Скопировать из основной" icon="pi pi-copy" (onClick)="copyDepartmentFromMain($event)" styleClass="mt-2 mr-2" [disabled]="cannotCopyFromMain"
                      pTooltip="Скопировать отделы из основной организации" tooltipPosition="top"></p-button>

            <p-button label="Обновить" icon="pi pi-refresh" (onClick)="reloadDocContent($event)" styleClass="mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>

          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem!important">&nbsp;</th>
        <th pSortableColumn="CLIENTSNIKNAME" style="width:30%" pResizableColumn>Отдел (склад) <p-sortIcon field="CLIENTSNIKNAME"></p-sortIcon></th>
        <th pSortableColumn="CLIENTSNAME" style="width:60%" pResizableColumn>Полное название отдела (склада) <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
        <th pSortableColumn="CLICATEGORY" style="width:10%" pResizableColumn>Флаги <p-sortIcon field="CLICATEGORY"></p-sortIcon></th>
        <th style="width: 3rem"></th>
      </tr>

      <tr>
        <th style="width: 7rem">&nbsp;</th>
        <th><input pInputText type="text" [(ngModel)]="fvCLIENTSNIKNAME" (input)="departmentTable.filter($event.target.value, 'CLIENTSNIKNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="fvCLIENTSNAME" (input)="departmentTable.filter($event.target.value, 'CLIENTSNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th><input pInputText type="text" [(ngModel)]="fvCLICATEGORY" (input)="departmentTable.filter($event.target.value, 'CLICATEGORY', 'eq')" placeholder="Поиск" class="p-column-filter"></th>

        <th></th>
      </tr>

    </ng-template>
    <ng-template pTemplate="body" let-department let-editing="editing" let-ri="rowIndex">
      <tr [pSelectableRow]="department" [pEditableRow]="department">

        <td>
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onDiRowEditInit(department)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onDiRowEditSave(department)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onDiRowEditCancel(department, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="department.CLIENTSNIKNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{department.CLIENTSNIKNAME}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="department.CLIENTSNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{department.CLIENTSNAME}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input"><p-inputMask [(ngModel)]="department.CLICATEGORY" autoClear="false" mask="9?9999" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()"></p-inputMask></ng-template>
            <ng-template pTemplate="output"><div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{department.CLICATEGORY}}</div></ng-template>
          </p-cellEditor>
        </td>

        <td>

          <button pButton pRipple type="button" icon="pi pi-check"
                  (click)="onExtendedEdit(department)"
                  class="p-button-rounded p-button-text p-button-success"
                  pTooltip="Соответствует основной компании" tooltipPosition="top"
                  *ngIf="checkExistenceOnTop(department)">
          </button>&nbsp;
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить отдел" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Добавить новый отдел (склад) в компанию" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все отделы" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mt-2 mr-2" [disabled]="editMode || noItems"
                      pTooltip="Удалить всех отделы в компании" tooltipPosition="top"></p-button>
            <p-button label="Удалить отдел (склад)" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mt-2 mr-2" [disabled]="editMode || !selectedDepartment"
                      pTooltip="Удалить выбранный отдел (склад)" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">Отделы отсутствуют</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #docitemloading>
  <p>Отделы загружаются...</p>
</ng-template>
